import { Component, OnInit, ViewChild } from '@angular/core'
import { EntityGroupODataService, IEntityGroup, IFacility } from '@exchange/domain/.'
import { ActivatedRoute, Router } from '@angular/router'
import { ToastrService } from 'ngx-toastr'
import {
  ActionButtonsColumnRendererComponent,
  ConfirmModalComponent,
  GridWrapperComponent,
  Option
} from 'common-components'
import { BsModalService } from 'ngx-bootstrap/modal'

@Component({
  selector: 'app-entity-group-list',
  templateUrl: './entity-group-list.component.html',
  standalone: false
})
export class EntityGroupListComponent implements OnInit {
  model: IEntityGroup = null
  states: Option[] = []

  @ViewChild('grid', { static: true }) grid: GridWrapperComponent

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private odata: EntityGroupODataService,
    private toastr: ToastrService,
    private modalService: BsModalService
  ) {}

  ngOnInit() {
    this.initializeGrid()
    const sm = this.route.snapshot.queryParams['successMessage']
    if (sm) {
      this.toastr.success(sm)
    }
  }

  addEntity(): void {
    this.router.navigate(['/system', 'entitygroups', 0])
  }

  editClicked(data) {
    const model = data as IFacility
    this.router.navigate(['/system', 'entitygroups', model.Id])
  }

  deleteClicked(data) {
    this.model = data as IEntityGroup
    this.modalService
      .show(ConfirmModalComponent, {
        initialState: {
          title: `Delete Entity Group?`,
          message: `Are you sure you want to delete the selected Entity Group?`
        }
      })
      .content.onClose.subscribe(userConfirm => userConfirm && this.deleteModel())
  }

  deleteModel(): void {
    this.odata
      .delete(this.model.Id)
      .exec()
      .subscribe(response => this.grid.getData())
  }

  initializeGrid() {
    this.grid.gridOptions.context = {
      canEdit: true,
      canDelete: true,
      editHandler: this.editClicked.bind(this),
      deleteHandler: this.deleteClicked.bind(this)
    }
    this.grid.gridOptions.columnDefs = [
      {
        headerName: '',
        field: 'Actions',
        pinned: 'left',
        width: 100,
        cellRenderer: ActionButtonsColumnRendererComponent
      },
      {
        headerName: 'CHI Entity Group ID',
        field: 'Id',
        width: 75,
        cellRenderer: GridWrapperComponent.TooltipRenderer(),
        filter: 'agNumberColumnFilter',
        filterParams: { newRowsAction: 'keep' }
      },
      {
        headerName: 'Name',
        field: 'Name',
        width: 100,
        cellRenderer: GridWrapperComponent.TooltipRenderer(),
        filter: 'agTextColumnFilter',
        filterParams: { newRowsAction: 'keep' }
      }
    ]
    this.grid.odata = this.odata
  }
}
